import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; 
import './FAQ.scss';
import '../Webpage/HomePage.scss'; 
import logoImage_1 from '../../assets/White PNG 1.png';
import logoImage_2 from '../../assets/Black PNG 1.png';


interface FaqItem {
  id: number;
  question: string;
  answer: string;
  warning?: boolean;
  action?: boolean;
  restriction?: boolean;
  important?: boolean;
  status?: string;
}

interface FaqPageProps {
  theme: string;
}

const FaqPage: React.FC<FaqPageProps> = ({ theme }) => {
  const [faqs, setFaqs] = useState<FaqItem[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchFaqs = async () => {
      setLoading(true);
      try {
        const response = await fetch('https://api.neontradepro.com/faqs/');
        if (!response.ok) {
          throw new Error('خطا در دریافت سوالات از سرور');
        }
        const data: FaqItem[] = await response.json();
        setFaqs(data);
      } catch (error) {
        console.error("Failed to fetch FAQs:", error);
        setFaqs([]);
      } finally {
        setLoading(false);
      }
    };

    fetchFaqs();
  }, []);

  const getIconForFaq = (faqItem: FaqItem) => {
    if (faqItem.action) return <span className="faq-icon-action">✅</span>;
    if (faqItem.restriction) return <span className="faq-icon-restriction">❌</span>;
    if (faqItem.warning) return <span className="faq-icon-warning">⚠️</span>;
    if (faqItem.important) return <span className="faq-icon-important">📌</span>;
    if (faqItem.status) return <span className="faq-icon-status">{faqItem.status}</span>;
    return null;
  };
  return (
    <div className={`faq-page ${theme}`} dir="rtl">
       <header className='header'>
        <nav className='nav-container'>
          <div className='logo'>
            <Link to={`/?theme=${theme}`}>
              <img src={theme === 'dark' ? logoImage_1 : logoImage_2} alt='لوگوی نئون' />
            </Link>
          </div>
        </nav>
      </header>
      
      <div className="faq-page-header">
        <h2>سوالات متداول سیستم TMP</h2>
        <p>پاسخ به سوالات رایج شما در مورد پلتفرم و خدمات TMP.</p>
      </div>

      <div className="faq-content-container">
        {loading && <p className="faq-loading">در حال بارگذاری سوالات...</p>}

        {!loading && faqs.length === 0 && (
          <p className="faq-empty">در حال حاضر سوال متداولی ثبت نشده است.</p>
        )}

        {!loading && faqs.map((faq) => (
          <details key={faq.id} className="faq-item">
            <summary className="faq-question">
              {getIconForFaq(faq)} {faq.question}
            </summary>
            <div className="faq-answer">
              <p>{faq.answer}</p>
            </div>
          </details>
        ))}
      </div>
    </div>
  );
};

export default FaqPage;